import { render, staticRenderFns } from "./DFormSummary.vue?vue&type=template&id=295eb544&scoped=true&"
import script from "./DFormSummary.vue?vue&type=script&lang=js&"
export * from "./DFormSummary.vue?vue&type=script&lang=js&"
import style0 from "./DFormSummary.vue?vue&type=style&index=0&id=295eb544&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295eb544",
  null
  
)

export default component.exports